import { useSnapshot } from 'valtio';

import { toastsState } from '.';

function useToasts() {
  const { toasts, incomingCallToasts } = useSnapshot(toastsState);
  return { toasts, incomingCallToasts };
}

export default useToasts;
